// extracted by mini-css-extract-plugin
export var bodySections = "_b7-8";
export var gray = "_b7-7";
export var green = "_b7-4";
export var iconContainer = "_b7-9";
export var iconWidgetContainer = "_b7-1";
export var phoneIcon = "_b7-2";
export var red = "_b7-5";
export var statusDot = "_b7-3";
export var widgetContainer = "_b7-0";
export var yellow = "_b7-6";